import React, { useState, useRef, useEffect } from "react";
import search_svg from "../../assets/images/svg/search.svg";
import closeIpSmall from "../../assets/images/svg/closeIpSmall.svg";
import closeInput from "../../assets/images/svg/closeInput.svg";
const SearchButton2 = ({
  search,
  setSearch,
  width,
  handleRef,
  type,
  classes,
  closeBtn,
  from,
  ariaLabel = "Search",
}) => {
  const inputRef = useRef(null);
  const closeRef = useRef(null);
  const searchButtonRef = useRef(null);
  const [isInputOpen, setIsInputOpen] = useState(false);
  const [isButton, setIsButton] = useState(true);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const handleClick = () => {
    setIsButtonClicked(true);
    setIsInputOpen(true);
    setTimeout(() => {
      closeRef.current.style.display = "block";
      inputRef.current.focus();
    }, 300);
    searchButtonRef.current.style.display = "none";
  };
  const handleClose = () => {
    setIsButtonClicked(false);
    closeRef.current.style.display = "none";
    setSearch("", true);
    setIsInputOpen(false);
    setTimeout(() => {
      searchButtonRef.current.style.display = "flex";
    }, 300);
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    if (isButtonClicked) {
      setIsButton(false);
    } else {
      setIsButton(true);
    }
  }, [isButtonClicked]);

  useEffect(() => {
    !isButton && inputRef.current.focus();
  }, [isButton]);

  return (
    <div className={classes}>
      <img
        className={`${
          !isInputOpen
            ? "search_icon_btn"
            : "search_icon_btn search_btn_when_open"
        } clickable`}
        src={search_svg}
        alt=""
        onClick={handleClick}
      />
      {/* <input
        ref={inputRef}
        value={search}
        className={
          !isInputOpen
            ? "search_button"
            : from && from === "portfolio"
            ? "search_button search_main_ip_btn_open_portfolio"
            : "search_button search_main_ip_btn_open"
        }
        onChange={handleChange}
        onClick={handleClick}
      /> */}

      <input
        id="search-instrument"
        ref={inputRef}
        value={search}
        className={
          !isInputOpen
            ? "search_button"
            : from && from === "portfolio"
            ? "search_button search_main_ip_btn_open_portfolio"
            : "search_button search_main_ip_btn_open"
        }
        onChange={handleChange}
        type={"text"}
        aria-label={ariaLabel}
        aria-hidden={isButton}
        tabIndex={isButton ? -1 : 0}
      />
      <button
        ref={searchButtonRef}
        aria-label="Search"
        //  style={{ display: isButton ? "flex" : "none" }}
        className="search-actual-button outlined"
        style={{ top: "-2px" }}
        onClick={(e) => handleClick(e)}
      >
        <img src={search_svg} alt="" />
      </button>

      {/* <img
        ref={closeRef}
        className={`${
          !isInputOpen
            ? "close_btn_input"
            : "close_btn_input close_btn_when_open"
        } clickable`}
        src={closeBtn === "small" ? closeIpSmall : closeInput}
        alt="close"
        onClick={handleClose}
      /> */}
      <button
        aria-label="Close Search"
        className={`${
          !isInputOpen
            ? "close_btn_input"
            : "close_btn_input close_btn_when_open"
        } clickable`}
        ref={closeRef}
        onClick={handleClose}
      >
        {" "}
        <img
          className=""
          src={closeBtn === "small" ? closeIpSmall : closeInput}
          alt="close"
        />
      </button>
    </div>
  );
};

export default SearchButton2;
